import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((t: typeof theme) => ({
  '@keyframes show': {
    from: { opacity: 0, transform: 'scale(0.95)' },
    to: { opacity: 1, transform: 'scale(1)' },
  },

  thumb: {
    position: 'relative',
    border: `.0631rem solid ${t.gray03}`,
    backgroundColor: t.white,
  },

  disabled: {
    opacity: 0.3,
  },

  active: {
    boxShadow: `0 0 0 .2rem ${t.linkColor}`,

    '&:focus, &:active:focus': {
      outline: '0',
      boxShadow: `0 0 0 .2rem ${t.linkColor}`,
    },
  },

  imageOverlay: {
    display: 'block',
    width: '100%',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    animation: '$show 200ms ease',
  },

  expandButton: {
    display: 'block',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: '100%',
    cursor: 'pointer',
    userSelect: 'none',
    padding: 0,
    border: 0,
    borderRadius: 0,
    font: 'inherit',
    fontSize: 'inherit',
    color: 'inherit',
    background: 'transparent',

    '&:focus, &:active:focus': {
      outline: '0',
    },
  },

  menuBackground: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '100%',
    height: '50%',
    background: 'linear-gradient(180deg, rgba(0,0,0,0.3), rgba(0,0,0,0) 100%)',
  },

  contextualMenu: {
    position: 'absolute',
    top: 0,
    right: '.2rem',
  },
}))

export default useStyles
